<div class="add-card">
    <div class="header">
        <h3>Use New Card:</h3>
        <a *ngIf="hasCardsOnFile" (click)="goToSavedCards()"
            >Back to Saved Cards</a
        >
    </div>

    <form *ngIf="!isStripeEnabled && form" [formGroup]="form">
        <ols-credit-card-information
            [surchargeSettings]="surchargeSettings"
        ></ols-credit-card-information>
        <mat-checkbox
            color="primary"
            class="save-card"
            qa="save-card"
            name="save-card"
            [disableRipple]="true"
            formControlName="saveCardOnFile"
        >
            Save card on file
        </mat-checkbox>
    </form>

    <div *ngIf="isStripeEnabled">
        <ols-credit-card-information
            [surchargeSettings]="surchargeSettings"
        ></ols-credit-card-information>
        <form *ngIf="form" [formGroup]="form">
            <mat-checkbox
                color="primary"
                class="save-card"
                qa="save-card"
                name="save-card"
                [disableRipple]="true"
                formControlName="saveCard"
            >
                Save card on file
            </mat-checkbox>
        </form>
    </div>
</div>
